import { render } from "./mProductCenter.vue?vue&type=template&id=9c89d28a&scoped=true"
import script from "./mProductCenter.vue?vue&type=script&lang=js"
export * from "./mProductCenter.vue?vue&type=script&lang=js"

import "./mProductCenter.vue?vue&type=style&index=0&id=9c89d28a&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c89d28a"]])

export default __exports__